import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as TableDownstreamOwnersFilteredByColumnQuery
export const TableDownstreamOwnerIdsFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamOwnerIdsFilteredByColumnQuery($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: { id: $columnId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
